import { CzechContractType } from "@tymbe/legislatives/czechia/CzechContractType";

export const czechContractTypeNameMap: Record<CzechContractType, string> = {
  [CzechContractType.DohodaOProvedeniPrace]: "Dohoda o provedení práce",
  [CzechContractType.DohodaOPracovniCinnosti]: "Dohoda o pracovní činnosti",
  [CzechContractType.HlavniPracovniPomer]: "Hlavní pracovní poměr",
}
